import NextImage from "next/image"
import Image from "components/Image"
import cn from "classnames"
import richText from "utilities/richText"
import useWindowSize from "utilities/useWindowSize"

const SingleImage = ({ image }) => (
  <Image
    src={image?.filename}
    alt={image?.alt}
    placeholder={image?.blurDataURL ? "blur" : "empty"}
    blurDataURL={image?.blurDataURL}
    className="max-h-[450px]"
    style={{ width: "100%", height: "100%", objectFit: "contain" }}
    sizes="100vw, (min-width: 768px) 35vw"
    width={800}
    height={800}
  />
)

const ImageCollage = ({ images }) => (
  <div className="grid grid-cols-2 gap-5">
    <div className="col-span-2 max-h-[262px] overflow-hidden">
      <Image
        src={images[0]?.filename}
        alt={images[0]?.alt}
        className="col-span-2"
        placeholder={images[0]?.blurDataURL ? "blur" : "empty"}
        blurDataURL={images[0]?.blurDataURL}
        sizes="100vw, (min-width: 768px) 35vw"
        style={{ width: "100%", height: "auto" }}
        width={1000}
        height={445}
      />
    </div>
    <div className="h-[162px] overflow-hidden">
      <Image
        src={images[1]?.filename}
        alt={images[1]?.alt}
        placeholder={images[1]?.blurDataURL ? "blur" : "empty"}
        blurDataURL={images[1]?.blurDataURL}
        className="object-cover w-full h-full"
        sizes="(min-width: 768px) 15vw"
        width={630}
        height={445}
      />
    </div>
    <div className="h-[162px] overflow-hidden">
      <Image
        src={images[2].filename}
        alt={images[2].alt}
        placeholder={images[2]?.blurDataURL ? "blur" : "empty"}
        blurDataURL={images[2]?.blurDataURL}
        className="object-cover w-full h-full"
        sizes="(min-width: 768px) 15vw"
        width={630}
        height={445}
      />
    </div>
  </div>
)

export default function ImageAndContent({ blok }) {
  const width = useWindowSize().width

  const section = cn("bg-white px-5", { "bg-primary": blok.background_color === "primary" })

  const container = cn(
    "image-content-container flex flex-col gap-4 md:gap-8 py-12 items-center mx-auto max-w-screen-xl",
    {
      "md:flex-row-reverse justify-end": blok.orientation === "content_first",
      "md:flex-row": blok.orientation === "image_first",
    },
  )

  const image = "w-full basis-1/2"

  return (
    <section className={section}>
      <div className={container}>
        <div className={image}>
          {blok.images?.length < 3 || width < 768 ? (
            blok.images[0] ? (
              <SingleImage image={blok.images[0]} />
            ) : (
              <NextImage
                src="/assets/placeholder.png"
                alt="Husband Wife Law team"
                style={{ width: "100%", height: "auto" }}
                sizes="100vw, (min-width: 768px) 35vw"
                width={800}
                height={800}
              />
            )
          ) : (
            <ImageCollage images={blok.images} />
          )}
        </div>

        <div className={cn("image-content basis-1/2", { "text-white": blok.background_color === "primary" })}>
          {blok.eyebrow ? (
            <div className="uppercase pb-2 flex">
              <span className={cn("eyebrow text-primary", { "text-white": blok.background_color === "primary" })}>
                {blok.eyebrow}
              </span>
            </div>
          ) : null}
          <h2 className={cn("text-primary mb-6", { "text-white": blok.background_color === "primary" })}>
            {blok.heading}
          </h2>
          <div className="leading-8 prose-p:mb-1">{richText(blok.content)}</div>
        </div>
      </div>
    </section>
  )
}
